var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "default-page" } }, [
    _c("div", { staticClass: "container full-width" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-table" },
          [
            _c("b-table", {
              staticClass: "list-table",
              attrs: {
                responsive: "",
                "sort-by": _vm.sort_by,
                "sort-asc": _vm.sort_asc,
                fields: _vm.fields,
                items: _vm.companies,
                "show-empty": ""
              },
              on: {
                "update:sortBy": function($event) {
                  _vm.sort_by = $event
                },
                "update:sort-by": function($event) {
                  _vm.sort_by = $event
                },
                "update:sortAsc": function($event) {
                  _vm.sort_asc = $event
                },
                "update:sort-asc": function($event) {
                  _vm.sort_asc = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "empty",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n                        No companies found\n                    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(action)",
                  fn: function(data) {
                    return [
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            attrs: {
                              href: _vm.$laravelRoute(
                                "companies.show",
                                data.item.id
                              )
                            }
                          },
                          [_vm._v("View")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            attrs: {
                              href: _vm.$laravelRoute(
                                "companies.edit",
                                data.item.id
                              )
                            }
                          },
                          [_vm._v("Edit")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            attrs: { href: "#!" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.deleteCompany(data.item)
                              }
                            }
                          },
                          [_vm._v("Delete")]
                        )
                      ])
                    ]
                  }
                },
                {
                  key: "cell(website)",
                  fn: function(data) {
                    return [
                      data.item.website
                        ? _c(
                            "a",
                            {
                              staticClass: "link",
                              attrs: { href: data.item.website }
                            },
                            [_vm._v(_vm._s(data.item.website))]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(status)",
                  fn: function(data) {
                    return [
                      data.item.status_id === 1
                        ? _c("span", { staticClass: "text-success" }, [
                            _vm._v("Active")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      data.item.status_id === 2
                        ? _c("span", { staticClass: "text-info" }, [
                            _vm._v("Preview")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      data.item.status_id === 3
                        ? _c("span", { staticClass: "text-warning" }, [
                            _vm._v("Stock Only")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      data.item.status_id === 4
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v("Blocked")
                          ])
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(user_count)",
                  fn: function(data) {
                    return [
                      data.item.users_count
                        ? [_vm._v(_vm._s(data.item.users_count))]
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bottom-table" },
          [
            _vm.total > 0
              ? _c("b-pagination", {
                  attrs: { "total-rows": _vm.total, "per-page": _vm.per_page },
                  model: {
                    value: _vm.current_page,
                    callback: function($$v) {
                      _vm.current_page = $$v
                    },
                    expression: "current_page"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-result-top" }, [
      _c("div", { staticClass: "top" }, [
        _c("div", { staticClass: "left" }, [
          _c("h2", [
            _vm._v(
              "\n                            Companies\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom" })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e5132c6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e5132c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Companies/List.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7e5132c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Companies/List.vue
// module chunks = 0